import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { injectIntl } from '../../../util/reactIntl';

const TimeSelectFilter = ({ options, queryParamNames, onSelect, intl, label, initialValues }) => {
  // Initialize the state based on initialValues
  const initialTime = initialValues[queryParamNames[0]] || '';
  const [selectedTime, setSelectedTime] = useState(initialTime);

  // Update state if initialValues prop changes
  useEffect(() => {
    if (initialValues[queryParamNames[0]] !== selectedTime) {
      setSelectedTime(initialValues[queryParamNames[0]] || '');
    }
  }, [initialValues, queryParamNames, selectedTime]);

  const handleChange = (event) => {
    const { value } = event.target;
    const queryParamName = queryParamNames[0];
    setSelectedTime(value);
    onSelect({ [queryParamName]: value });
  };

  const handleClearFilter = () => {
    setSelectedTime(''); // Reset the selected time
    onSelect({ [queryParamNames[0]]: '' }); // Clear the filter
  };

  return (
    <Box mb={4}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          mt: 4,
          mb: 2,
        }}
      >
        <Typography variant="h5">{label}</Typography>
        <Button color="secondary" onClick={handleClearFilter} sx={{ p: 0 }} variant="text">
          <FormattedMessage id="FilterForm.clear" />
        </Button>
      </Box>

      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select label={label} onChange={handleChange} value={selectedTime}>
          {options.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {intl.formatMessage({ id: option.label })}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default injectIntl(TimeSelectFilter);
